// Depends
import { subGroup, route, companyMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, companyMeta('Lista de Corpo Clínico')),
  route('create', '/create', Form, companyMeta('Adicionar Corpo Clínico')),
  route('edit', '/:id/edit', Form, companyMeta('Editar Corpo Clínico'))
]

export default subGroup('/staffs', routes)



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/routes.js